import { useEffect, useState } from 'react';
import { HitApi } from '../../Api/ApiHit';
import { deleteBilling, searchBilling, updateBilling } from '../../constant/Constant';
import { useSelector, useDispatch } from 'react-redux';
import { setApiJson } from '../../redux/Actions/ApiAction';
import { getSelectedUnit } from '../../storage/Storage';
import { Calendar, ContactRound, Eye, IndianRupee, ReceiptIndianRupee, Trash2, User, CreditCard } from 'lucide-react';
import AppTable from '../../components/AppTable/AppTable';
import { setDataAction } from '../../redux/Actions/SetDataAction';
import { SET_BILLING__DATA } from '../../redux/ActionName/ActionName';
import BillPreviewModal from '../../WebView/Billing/GenerateBill';
import { hasPermission } from '../../utils/permissionUtils';
import { setPagination } from '../../redux/Actions/TableAction';
import FilterComponent from '../../components/Filter/FilterComponent'; // Import the FilterComponent
import PageHeader from '../../PageHeader/PageHeader'; // Optional: Add header

function PaidBIlls({ noGst, allbills }) {
    const BillingReducer = useSelector((state) => state.BillingReducer);
    const TableDataReducer = useSelector((state) => state.TableReducer);
    const dispatch = useDispatch();
    const getUnit = getSelectedUnit();
    const [showPreview, setShowPreview] = useState(false);
    const [billIndex, setBillIndex] = useState(null);
    const ShowToggle = hasPermission('quicksale', 'delete');

    // Filter States
    const [statusFilter, setStatusFilter] = useState("true");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isLoading, setIsLoading] = useState(false);


    const statusOptions = [

        { value: "true", label: "All Bills" },
        { value: "false", label: "Deleted Bills" }
    ]

    useEffect(() => {
        loadBilling();
    }, [
        TableDataReducer.pagination.page,
        TableDataReducer.pagination.limit,
        statusFilter, // Add filter dependencies
        startDate,
        endDate
    ]);

    const loadBilling = () => {
        setIsLoading(true);

        // Build date range filter
        let dateRangeFilter = {};
        if (startDate && endDate) {
            dateRangeFilter = {
                $gte: new Date(startDate).getTime(),
                $lte: new Date(endDate).getTime() + 24 * 60 * 60 * 1000 - 1,
            };
        } else if (startDate) {
            dateRangeFilter = {
                $gte: new Date(startDate).getTime(),
            };
        } else if (endDate) {
            dateRangeFilter = {
                $lte: new Date(endDate).getTime() + 24 * 60 * 60 * 1000 - 1,
            };
        } else if (!allbills) {
            // Default to today's records if no custom date range and not showing all bills
            dateRangeFilter = {
                $gte: getTodayTimestamps().startTimestamp,
                $lte: getTodayTimestamps().endTimestamp
            };
        }

        const json = {
            page: TableDataReducer.pagination.page,
            limit: TableDataReducer.pagination.limit,
            search: {
                // Apply date filter logic
                ...(Object.keys(dateRangeFilter).length > 0 && {
                    createdAt: dateRangeFilter
                }),
                unitIds: getUnit?._id,
                billingStatus: true,
                noGst: noGst ? noGst : false,
                status: statusFilter === "true" ? true : false
                // status: true
            },
        };

        HitApi(json, searchBilling).then((res) => {
            console.log("res----", res);

            const paginationData = {
                total: res?.totalDocs || res?.totalPages || 0,
                page: TableDataReducer.pagination.page,
                limit: TableDataReducer.pagination.limit
            };

            dispatch(setPagination(paginationData));

            if (res?.message === 'Billing records retrieved successfully' && res?.data) {
                console.log('Billing data:-----', res?.data);
                dispatch(setDataAction(res?.data, SET_BILLING__DATA));
            }
            setIsLoading(false);
        })
            .catch((error) => {
                console.error('Error fetching billing data:', error);
                dispatch(setApiJson({}));
                setIsLoading(false);
            });
    };

    // Rest of your existing functions remain the same...
    const formatDateWithTime = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);

            const dateFormatted = date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: '2-digit'
            });

            const timeFormatted = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });

            return { date: dateFormatted, time: timeFormatted };
        } catch (error) {
            return { date: 'Invalid Date', time: '' };
        }
    };

    const formatPaymentMethodsForBadges = (paymentMethod) => {
        if (!paymentMethod || !Array.isArray(paymentMethod)) return [];
        const activeMethods = paymentMethod.filter(method => method.price > 0);
        return activeMethods.map(method => method.title);
    };

    const deleteBill = (row) => {
        if (window.confirm("Are you sure you want to continue?")) {
            const json = { _id: row?._id, status: false };
            HitApi(json, updateBilling).then((res) => {
                console.log("res", res);
                if (res?.message == "Billing updated successfully") {
                    loadBilling();
                }
            });
        }
    };

    function getTodayTimestamps() {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
        return {
            startTimestamp: start.getTime(),
            endTimestamp: end.getTime(),
        };
    }

    const baseIndex = (TableDataReducer.pagination.page - 1) * TableDataReducer.pagination.limit;

    // Update table headers to reflect filtered status
    const tableHeaders = [
        {
            title: "S.No",
            key: "serialNumber",
            width: "60px",
            align: "center",
            render: (_, row, index) => {
                const serialNumber = baseIndex + index + 1;
                return (
                    <div className="text-center">
                        <span className="text-sm font-medium text-gray-900">{serialNumber}</span>
                    </div>
                );
            }
        },
        // ... rest of your existing table headers remain the same
        {
            title: "Client Name",
            key: "clientName",
            render: (value, row) => (
                <div className="flex items-center gap-2">
                    <span className="font-medium text-gray-900">
                        {row.clientInfo?.name || value || 'N/A'}
                    </span>
                </div>
            )
        },
        {
            title: "Contact",
            key: "phoneNumber",
            render: (value, row) => (
                <div className="flex items-center gap-2">
                    <span className="font-medium text-gray-900">
                        {row.clientInfo?.phoneNumber || value || 'N/A'}
                    </span>
                </div>
            )
        },
        {
            title: "Bill no.",
            key: "billNo",
            render: (value, row) => (
                <div className="flex items-center gap-2">
                    <span className="font-medium text-gray-900">
                        {row.billNo || value || 'N/A'}
                    </span>
                </div>
            )
        },
        {
            title: "Price/Paid/Balance",
            key: "Price/Paid/Balance",
            render: (value, row) => {
                return (
                    <div className="flex items-center gap-2">
                        <span className="font-medium text-gray-900">
                            {`₹${row?.billSummary?.grandTotal} / ${row?.billSummary?.payingNow} / ${row?.billSummary?.duePayment}`}
                        </span>
                    </div>
                );
            }
        },
        {
            title: "Payment Method",
            key: "paymentMethod",
            render: (value, row) => {
                const paymentMethods = formatPaymentMethodsForBadges(row.paymentMethod);

                if (paymentMethods.length === 0) return 'N/A';

                const methodColors = {
                    'CASH': 'bg-green-100 text-green-800',
                    'CARD': 'bg-blue-100 text-blue-800',
                    'UPI': 'bg-purple-100 text-purple-800',
                    'WALLET': 'bg-orange-100 text-orange-800'
                };

                return (
                    <div className="flex flex-wrap gap-1">
                        {paymentMethods.map((method, index) => (
                            <span
                                key={index}
                                className={`px-2 py-1 rounded-full text-xs font-medium ${methodColors[method] || 'bg-gray-100 text-gray-800'}`}
                            >
                                {method}
                            </span>
                        ))}
                    </div>
                );
            }
        },
        {
            title: "Date & Time",
            key: "createdAt",
            render: (value) => {
                const formatted = formatDateWithTime(value);
                return (
                    <div className="flex items-center gap-2">
                        <Calendar size={16} className="text-gray-400" />
                        <div className="text-sm">
                            <div className="text-gray-900 font-medium">{formatted.date}</div>
                            <div className="text-gray-600 text-xs">{formatted.time}</div>
                        </div>
                    </div>
                );
            }
        },
        {
            title: "Status",
            key: "status",
            render: (value, row) => {
                const status = row.billingStatus ? "Paid" : "Pending";
                const statusColors = {
                    'Paid': 'bg-green-100 text-green-800',
                    'Pending': 'bg-yellow-100 text-yellow-800',
                    'Cancelled': 'bg-red-100 text-red-800'
                };
                return (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusColors[status] || 'bg-gray-100 text-gray-800'}`}>
                        {status}
                    </span>
                );
            }
        },
        {
            title: "Actions",
            key: "actions",
            align: "center",
            render: (value, row, index) => (
                <div className='flex gap-2'>
                    <div onClick={() => showBill(row, index)} className="cursor-pointer p-2 gap-2 bg-purple-100 rounded-full flex items-center justify-center">
                        <Eye size={16} /><span>View Bill</span>
                    </div>
                    {ShowToggle && statusFilter === "true" && <div onClick={() => deleteBill(row, index)} className="cursor-pointer p-1 gap-2 rounded-full flex items-center justify-center">
                        <Trash2 color='red' />
                    </div>}
                </div>
            )
        }
    ];

    const showBill = (row, index) => {
        setBillIndex(index);
        setShowPreview(true);
    };

    return (
        <div className='p-5 bg-gray-50'>
            {/* Header with Filter Component */}



            {/* Filter Component Integration */}
            {allbills &&
                <div className='flex justify-between mb-6'>
                    <div>
                        <PageHeader title={"All Bills"} />
                    </div>
                    <div>
                        <FilterComponent statusOptions={statusOptions} forBills={true} statusFilter={statusFilter} setStatusFilter={setStatusFilter} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} isLoading={isLoading} className="rounded-xl" />
                    </div>
                </div>
            }


            {/* Summary Stats (Optional Enhancement) */}
            {allbills && <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-white rounded-lg p-4 border">
                    <div className="flex items-center space-x-2">
                        <ReceiptIndianRupee className="h-5 w-5 text-blue-500" />
                        <span className="text-sm text-gray-600">Total Bills</span>
                    </div>
                    <p className="text-2xl font-bold text-gray-900">
                        {BillingReducer?.billingData?.length || 0}
                    </p>
                </div>

                <div className="bg-white rounded-lg p-4 border">
                    <div className="flex items-center space-x-2">
                        <IndianRupee className="h-5 w-5 text-green-500" />
                        <span className="text-sm text-gray-600">Total Revenue</span>
                    </div>
                    <p className="text-2xl font-bold text-gray-900">
                        ₹{BillingReducer?.billingData?.reduce((sum, bill) =>
                            sum + (parseFloat(bill?.billSummary?.grandTotal) || 0), 0
                        ).toLocaleString() || 0}
                    </p>
                </div>

                <div className="bg-white rounded-lg p-4 border">
                    <div className="flex items-center space-x-2">
                        <CreditCard className="h-5 w-5 text-purple-500" />
                        <span className="text-sm text-gray-600">Avg. Bill Value</span>
                    </div>
                    <p className="text-2xl font-bold text-gray-900">
                        ₹{BillingReducer?.billingData?.length > 0 ?
                            (BillingReducer?.billingData?.reduce((sum, bill) =>
                                sum + (parseFloat(bill?.billSummary?.grandTotal) || 0), 0
                            ) / BillingReducer?.billingData?.length).toFixed(0) : 0}
                    </p>
                </div>
            </div>}

            {/* Table with improved styling */}
            <div className="bg-white rounded-xl border overflow-hidden p-4 ">
                <div className="p-6 border-b border-gray-200">
                    <h3 className={`text-lg font-semibold ${statusFilter === "true" ? "text-gray-900" : "text-red"} `}>
                        {statusFilter === "true" ? "Billing Records" : "Deleted Billing Records"}
                        {(statusFilter !== "all" || startDate || endDate) && (
                            <span className="ml-2 text-sm text-blue-600 bg-blue-100 px-2 py-1 rounded-full">
                                Filtered
                            </span>
                        )}
                    </h3>
                </div>

                <AppTable
                    TH={tableHeaders}
                    TD={BillingReducer?.billingData || []}
                    isLoading={isLoading}
                    emptyMessage={
                        (statusFilter !== "all" || startDate || endDate)
                            ? "No billing records found for the selected filters"
                            : "No billing records found"
                    }
                />
            </div>

            {/* Loading Overlay */}
            {isLoading && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-8 flex flex-col items-center space-y-4">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="text-gray-700 font-medium">Loading billing data...</p>
                    </div>
                </div>
            )}

            <BillPreviewModal
                isOpen={showPreview}
                onClose={() => setShowPreview(false)}
                billData={BillingReducer?.billingData?.[billIndex]}
                noModal={false}
            />
        </div>
    );
}

export default PaidBIlls;
